import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);
window.Vue = Vue
Vue.config.productionTip = false;
window.VueGlobal = Vue;

const mixin = {
  methods: {
    loadJs(jsArray) {
      jsArray.forEach(path => {
        let script = document.createElement('script');
        script.src = path;
        script.type = "text/javascript";
        document.body.appendChild(script);
      })
    },
    errorHandler(err) {
      let errorMessage = "";
      if (err.status == 500) {} else if (err.status == 401) {} else {
        if (err.data) {
          if (err.data.non_field_errors) {
            errorMessage = err.data.non_field_errors[0];
          } else {
            if (Object.keys(err.data).length > 0) {
              errorMessage = err.data[Object.keys(err.data)[0]][0];
            }
          }
        } else {
          if (err.non_field_errors) {
            errorMessage = err.non_field_errors[0];
          } else {
            if (Object.keys(err).length > 0) {
              errorMessage = err[Object.keys(err)[0]][0];
            }
          }
        }
        errorMessage = errorMessage ?
          errorMessage :
          "Something went wrong.";
      }
      return errorMessage;
    },
    toast(msg = "", className = 'toast-success', err) {
      let errMsg;
      if (msg) {
        errMsg = msg;
      } else {
        errMsg = this.errorHandler(err);
      }
      if ($('#toast-container').length > 0) {
        $('#toast-container .toast').text(errMsg);
      } else {
        M.toast({
          html: errMsg || "Oops, Something went wrong..!",
          displayLength: 4000,
          classes: className
        });
      }
    },
    jsonToFormdata(param) {
      let formdata = new FormData(),
        value, isString = true,
        isImagesArray = false;
      for (let key in param) {
        value = param[key];
        if (typeof value == 'string' || typeof value == 'object') {
          if (typeof value == 'object' && !Array.isArray(value)) {
            if (value && value.type && ((value.type.indexOf('image/') >= 0) || (value.type.indexOf('application/') >= 0))) {
              isString = true;
            } else {
              isString = false;
            }
          } else {
            if (Array.isArray(value)) {
              if (value[0]) {
                let valueObj = value[0];
                if (valueObj && valueObj.type && ((valueObj.type.indexOf('image/') >= 0) || (valueObj.type.indexOf('application/') >= 0))) {
                  value.forEach(arr => {
                    if (arr && arr.type && ((arr.type.indexOf('image/') >= 0) || (arr.type.indexOf('application/') >= 0))) {
                      isImagesArray = true;
                      formdata.append(key, arr)
                    }
                  });
                } else {
                  isImagesArray = false;
                  isString = false;
                }
              }
            } else {
              isString = false;
            }
          }
        } else {
          isString = false;
        }

        if (value && !isImagesArray) {
          isImagesArray = false;
          formdata.append(key, isString ? value : (typeof value == 'string' ? value : JSON.stringify(value)));
        }
      }
      return formdata;
    },
    scrollBottom(elem, callback) {
      if (!elem) elem = window;
      $(elem).on("scroll", (e) => {
        var docheight = e.target.scrollHeight - e.target.clientHeight;
        var scrollTop = e.target.scrollTop;
        var pctScrolled = Math.floor((scrollTop / docheight) * 100);
        if (pctScrolled == 100) {
          callback();
        }
      });

    },
    showNoDataBlock(elem = ".responsive-table", text = "No data found") {
      $('#nodatafoundid').remove();
      $(elem).eq(0).append(`<div id='nodatafoundid' class='nodata'><div class='nodata-found__div'><i class='material-icons'>supervisor_account</i><div> ${text}</div></div></div>`);
      $(elem).children().each((key, elem) => {
        if (elem.id != "nodatafoundid") {
          elem.style.opacity = 0;
          elem.style.maxHeight = 0;
          elem.style.overflow = "hidden";
        }
      })
    },
    hideNoDataBlock(elem = ".responsive-table") {
      $(elem).children().each((key, elem) => {
        if (elem.id == "nodatafoundid") {
          elem.remove();
        } else {
          if (elem.style.opacity == 0) {
            elem.style.maxHeight = "100%";
            elem.style.overflow = "auto";
            elem.style.opacity = 1;
          }
        }
      })
    }
  }
};

window.Constants = require('./core/constants');
// axios
require('./core/ajax')

// directives
require('./core/directives')

// Import moment
import moment from 'moment';
window.moment = moment;
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
window.distanceInWordsToNow = distanceInWordsToNow;
import uuid from 'uuid/v1';
window.uuid = uuid;

window.notificationHub = new Vue();


window.Vue = new Vue({
  router,
  mixins: [mixin],
  render: h => h(App)
}).$mount('#app')